import { Component } from '@angular/core';
import { MediaPanelInfo } from '../../../../../models/datamodel/mediasource.model';
import { BaseMediaSourcePanel } from '../basemediasource.panel';

@Component({
    selector: 'auzureblob-panel',
    templateUrl: './auzureblob.panel.html',
    styleUrls: ['./auzureblob.panel.css']
})
export class AzureBlobPanel extends BaseMediaSourcePanel {
    static GetInfo(): MediaPanelInfo {
        return { 
            ControlType: AzureBlobPanel,
            MediaType: 'a4281b52-c92a-4ab0-81ce-50275f7cfe02'
        };
    }
}
